import { gql } from '@apollo/client';

const STARTING_SOUND_ACTIVITY = gql`
  query startingSound($where: ActivityWhereInput!) {
    startingSound(where: $where) {
      title
      description
      book {
        id
        title
        characters {
          id
          character
          characterCase
          characterType
        }
      }
      activityType {
        name
      }
      activityTypeId
      url
    }
  }
`;

export default STARTING_SOUND_ACTIVITY;
